import ProvidersWrapper from './ProvidersWrapper';

export default ProvidersWrapper;
